const countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/ru.json"));

// Официальное именование Китая слишком длинное, попросили поменять
export const getCountryName = (code, lang) => {
    if(code === 'CHN') return lang === 'en' ? 'China' : 'Китай';
    if(code === 'RUS') return lang === 'en' ? 'Russia' : 'Россия';
    return countries.getName(code, lang);
};
